import parse, { DOMNode, Element, domToReact } from "html-react-parser";
import React from "react";

const replaceDomNode = (domNode: DOMNode) => {
  if ((domNode as Element).attribs) {
    const domNodeElement: Element = domNode as Element;
    if (domNodeElement.name === "html")
      return (
        <>
          {domToReact(
            (domNodeElement.children.find((child) => (child as Element).name === "body") as Element)?.children
          )}
        </>
      );
  } else return domNode;
};

export const parseHtml = (html: string) => parse(html, { replace: replaceDomNode });
